<div class="payment-breakdown">
  <div class="payment-breakdown-header">
    <div class="payment-breakdown-header-text">
      {{ "LABELS.PAYMENT_BREAKDOWN" | translate }}
    </div>
  </div>

  <div class="payment-breakdown-body" *ngIf="!isCollapsable">
    <!--Normal Items Row-->
    <div class="row payment-breakdown-body-row" *ngFor="let bill of normalJoinedItems">
      <div class="col-8 payment-breakdown-body-row-label">
        {{ bill?.description }}
        {{ bill.quantity > 1 ? " (x" + bill.quantity + ")" : "" }}
      </div>
      <div class="col-4 payment-breakdown-body-row-value">
        {{ bill?.price * bill?.quantity || 0 | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
      </div>
    </div>

    <!--Discounts Row-->
    <div class="row payment-breakdown-body-row" *ngFor="let bill of discountJoinedItems">
      <div class="col-8 payment-breakdown-body-row-label">
        {{ bill?.description }}
        {{ bill.quantity > 1 ? " (x" + bill.quantity + ")" : "" }}
      </div>
      <div class="col-4 payment-breakdown-body-row-value" [ngClass]="{ 'payment-breakdown-body-row-value-discount': isDiscount(bill) }">
        {{ discountsTotalSum || 0 | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
      </div>
    </div>
  </div>

  <app-lcl-payment-items
    *ngIf="isCollapsable"
    [pendingBills]="pendingBills"
    [productsByCompany]="[]"
    [isHasISF]="false"
    [isHasES]="false"
    [isBillLoading]="false"
    [isBooking]="false"
    [isMobileView]="isMobileView"
    [isCollapsed]="isCollapsed"
    [isShowAdditional]="false"
    [chargesText]="'LABELS.SHIPMENT_CHARGES'"
  ></app-lcl-payment-items>

  <div class="payment-breakdown-footer">
    <div class="row">
      <div class="col-8 payment-breakdown-body-row payment-breakdown-footer-row-label">
        {{ totalText | translate }}
      </div>
      <div class="col-4 payment-breakdown-footer-row-value" [ngClass]="{ 'payment-breakdown-footer-row-value-blue-mobile': isCollapsable }">
        {{ totalSum | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
      </div>
    </div>

    <ng-content select="[button]"></ng-content>

    <div *ngIf="notes.length" class="payment-breakdown-notes">
      <div class="payment-breakdown-notes-header">
        <img class="payment-breakdown-notes-icon" src="assets/icons/icon_warning_blue_sm.svg" alt="info symbol" />
        <p class="payment-breakdown-notes-title">{{ "LABELS.NOTES" | translate }}</p>
      </div>
      <ul>
        <li class="payment-breakdown-notes-item" *ngFor="let note of notes">{{ note | translate }}</li>
      </ul>
    </div>
  </div>
</div>
